import '../spring-grove-hero/index.css';
import './index.css';

import { Swiper } from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initSpringGroveCardSlider(root) {
  const swiperElement = root.querySelector('[data-sg-card-grid-swiper]');
  if (!swiperElement || swiperElement.classList.contains('swiper-initialized')) {
    return;
  }

  const slides = swiperElement.querySelectorAll('.swiper-slide');
  if (slides.length < 2) {
    return;
  }

  const prevElement = root.querySelector('[data-sg-card-grid-prev]');
  const nextElement = root.querySelector('[data-sg-card-grid-next]');
  const paginationElement = root.querySelector('[data-sg-card-grid-pagination]');

  [prevElement, nextElement].forEach((button) => {
    button?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      button.click();
    });
  });

  new Swiper(swiperElement, {
    modules: [Navigation, Pagination, A11y],
    grabCursor: true,
    watchOverflow: true,
    speed: 650,
    slidesPerView: 1.08,
    spaceBetween: 18,
    breakpoints: {
      640: {
        slidesPerView: 1.4,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 2.05,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3.05,
        spaceBetween: 28,
      },
    },
    navigation: prevElement && nextElement
      ? {
        prevEl: prevElement,
        nextEl: nextElement,
      }
      : undefined,
    pagination: paginationElement
      ? {
        el: paginationElement,
        clickable: true,
      }
      : undefined,
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous brand card',
      nextSlideMessage: 'Next brand card',
      paginationBulletMessage: 'Go to brand card {{index}}',
    },
  });
}

function initSpringGroveCardSliders() {
  document.querySelectorAll('[data-sg-card-grid-slider]').forEach((root) => {
    // Skip brand sliders — handled by brand-slider/index.js
    if (root.closest('.spring-grove-card-grid--brand')) {
      return;
    }
    initSpringGroveCardSlider(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSpringGroveCardSliders);
} else {
  initSpringGroveCardSliders();
}